import {Route, Routes} from 'react-router-dom';

import {List} from './List';

export default function TemplateInvoice() {

  return (
    <Routes>
      <Route path="/" element={<List/>}/>
    </Routes>
  );
}
